import { supabase } from '@readsavor/supabase-client';
import { HttpClient } from './client.js';
/**
 * 创建一个全局唯一的 HttpClient 实例
 * 这个实例现在是自包含的，不再需要外部初始化。
 */
export const httpClient = new HttpClient({
    baseURL: import.meta.env.PROD ? import.meta.env.VITE_API_URL : '/api',
    // A reasonable global timeout for most API calls.
    // Long-running tasks like PDF processing will override this in their specific client.
    timeout: 10000, // 10 seconds
    retries: 3,
});
// 导出 httpClient 实例，以便在外部访问其配置（例如 baseURL）
export const getHttpClientConfig = () => httpClient.getConfig();
// 监听认证状态变化并自动更新Token
supabase.auth.onAuthStateChange((event, session) => {
    const token = session?.access_token;
    if (token) {
        httpClient.setDefaultHeader('Authorization', `Bearer ${token}`);
    }
    else {
        httpClient.removeDefaultHeader('Authorization');
    }
});
//# sourceMappingURL=httpClientInstance.js.map